import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Show modal when controller connects (on page load)
    this.showModal()
  }

  showModal() {
    this.modalTarget.classList.remove('hidden')
    // Add fade-in animation
    setTimeout(() => {
      this.modalTarget.classList.add('opacity-100')
      this.modalTarget.classList.remove('opacity-0')
    }, 10)
  }

  closeModal() {
    // Add fade-out animation
    this.modalTarget.classList.add('opacity-0')
    this.modalTarget.classList.remove('opacity-100')
    
    // Hide modal after animation completes
    setTimeout(() => {
      this.modalTarget.classList.add('hidden')
    }, 300)
  }

  // Close modal when clicking on backdrop
  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
